<div class="erros-integracao-panel">

  <div class="erros-integracao-header">
    <h3>Integração</h3>
  </div>

  <div class="erros-integracao-filters">

    <div class="erros-filter-input-wrapper">
      <input type="text"
             placeholder="Filtrar"
             ng-model="vm.textInput"
             ng-change="vm.onTextInputChange()">
      <button type="button"
              class="erros-filter-clear-btn"
              ng-if="vm.textInput"
              ng-click="vm.clearTextInput(); $event.stopPropagation()">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="erros-filter-periodo-wrapper">
      <button type="button"
              class="erros-filter-periodo-btn"
              ng-click="vm.togglePeriodo($event)">
        <span>{{ vm.periodoLabel }}</span>
        <i class="fa fa-caret-down erros-filter-btn-icon"></i>
      </button>

      <div class="erros-periodo-dropdown"
           ng-show="vm.periodoOpen"
           ng-click="$event.stopPropagation()">
        <ul>
          <li ng-repeat="opt in vm.periodoOptions track by opt.value"
              ng-class="{'active': vm.periodoAplicado.modo === opt.value}">
            <a href="#" ng-click="vm.setPeriodo(opt.value, $event)">{{ opt.label }}</a>
          </li>
          <li class="divider" ng-if="vm.periodoAplicado.modo"></li>
          <li ng-if="vm.periodoAplicado.modo">
            <a href="#" class="erros-periodo-limpar" ng-click="vm.clearPeriodo($event)">
              <i class="fa fa-times"></i> Limpar período
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="erros-filter-status-wrapper">
      <button type="button"
              class="erros-filter-status-btn"
              ng-click="vm.toggleStatus($event)">
        <span>{{ vm.statusLabel }}</span>
        <i class="fa fa-caret-down erros-filter-btn-icon"></i>
      </button>

      <div class="erros-status-dropdown"
           ng-show="vm.statusOpen"
           ng-click="$event.stopPropagation()">
        <ul>
          <li ng-repeat="opt in vm.statusOptions track by opt.value"
              ng-class="{'active': vm.statusFilter === opt.value}">
            <a href="#" ng-click="vm.setStatus(opt.value, $event)">{{ opt.label }}</a>
          </li>
        </ul>
      </div>
    </div>

  </div>

  <div class="erros-integracao-body">

    <div class="erros-integracao-empty-state" ng-if="vm.isLoading">
      <i class="fa fa-spinner fa-spin"></i>
      <p>Carregando registros</p>
    </div>

    <div class="erros-integracao-empty-state" ng-if="!vm.isLoading && vm.erros.length === 0">
      <i class="fa fa-search"></i>
      <p>Nenhum registro encontrado</p>
    </div>

    <div class="erros-integracao-list"
         ng-if="!vm.isLoading && vm.erros.length > 0"
         infinite-scroll="vm.carregarMais()"
         infinite-scroll-parent="true"
         infinite-scroll-disabled="!vm.hasNextPage() || vm.isLoadingMore"
         infinite-scroll-immediate-check="false">
      <div class="erros-integracao-item" ng-repeat="erro in vm.erros track by erro.id">

        <div class="erros-integracao-item-propriedade">
          {{ erro.propriedade }}
        </div>

        <div class="erros-integracao-item-center">
          <div class="erros-integracao-item-title-row">
            <i class="fa erros-integracao-item-icon"
               ng-class="{
                 'fa-exclamation-triangle erros-item-icon--erro':        erro.status === 'erro',
                 'fa-hourglass-half erros-item-icon--pendente':          erro.status === 'pendente',
                 'fa-refresh fa-spin erros-item-icon--processando':      erro.status === 'processando',
                 'fa-check erros-item-icon--confirmado':                 erro.status === 'confirmado'
               }"></i>
            <div ng-if="erro.status === 'erro'" class="erros-integracao-item-title-with-info">
              <span class="erros-integracao-item-title">{{ erro.entidade }}</span>
              <span class="erros-integracao-item-info-icon"
                    uib-tooltip-html="erro._tooltipHtml"
                    tooltip-placement="auto bottom"
                    tooltip-append-to-body="true"
                    tooltip-class="erros-integracao-tooltip">
                <i class="fa fa-info-circle"></i>
              </span>
            </div>
            <span ng-if="erro.status !== 'erro'"
                  class="erros-integracao-item-title">{{ erro.entidade }}</span>
          </div>
          <div class="erros-integracao-item-date">
            {{ erro.dataRegistro || vm.formatarData(erro.dataOperacao) }}
          </div>
          <div class="erros-integracao-item-suporte-tag" ng-if="erro._limiteRetry">
            <i class="fa fa-ban"></i> Contate o suporte
          </div>
        </div>

        <div class="erros-integracao-item-actions">
          <button type="button"
                  class="btn btn-sm erros-integracao-btn-copy"
                  ng-click="vm.copiar(erro); $event.stopPropagation()"
                  uib-tooltip="{{ erro._copied ? 'Copiado!' : 'Copiar detalhes' }}"
                  tooltip-placement="left"
                  tooltip-append-to-body="true">
            <i class="fa" ng-class="erro._copied ? 'fa-check' : 'fa-copy'"></i>
          </button>
<button type="button"
                  class="btn btn-sm erros-integracao-btn-resync"
                  ng-if="erro.status === 'erro' || erro.status === 'pendente'"
                  ng-disabled="erro.syncing || erro._limiteRetry"
                  ng-click="vm.ressincronizar(erro); $event.stopPropagation()"
                  uib-tooltip="{{ erro._limiteRetry ? 'Limite de tentativas atingido. Contate o suporte.' : 'Ressincronizar' }}"
                  tooltip-placement="left"
                  tooltip-append-to-body="true">
            <i class="fa"
               ng-class="{'fa-refresh': !erro.syncing, 'fa-refresh fa-spin': erro.syncing}"></i>
          </button>
          <button type="button"
                  class="btn btn-sm erros-integracao-btn-redirect"
                  ng-if="vm.podeRedirecionar(erro)"
                  ng-disabled="erro._redirecting"
                  ng-click="vm.redirecionar(erro); $event.stopPropagation()"
                  uib-tooltip="Ir para o lançamento"
                  tooltip-placement="left"
                  tooltip-append-to-body="true">
            <i class="fa" ng-class="erro._redirecting ? 'fa-spinner fa-spin' : 'fa-sign-in'"></i>
          </button>
        </div>

      </div>

      <div class="erros-integracao-load-more" ng-if="vm.isLoadingMore">
        <i class="fa fa-spinner fa-spin"></i>
      </div>
    </div>

  </div>
</div>
